import { render, staticRenderFns } from "./RightsFundDeduct.vue?vue&type=template&id=cf2d0b18"
import script from "./RightsFundDeduct.vue?vue&type=script&lang=js"
export * from "./RightsFundDeduct.vue?vue&type=script&lang=js"
import style0 from "./RightsFundDeduct.vue?vue&type=style&index=0&id=cf2d0b18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports